import { HostGrantProvider, type HostProvider } from '@tasks/bridge-client/host';
import type { HostMode } from './mode.js';

/**
 * The ONE host of this document (the provider outlives React's mounts: `HostGrantProvider` keeps it for the document). `null` when the
 * mode has no host (own): nothing in the app then asks for a pass.
 */
export function hostFor(mode: HostMode): HostProvider | null {
  if (mode.kind === 'own') return null;
  const { vittoOrigin, apiOrigin, appName, parentOrigins } = mode.config;
  return HostGrantProvider({ vittoOrigin, apiOrigin, appName, parentOrigins });
}
